import { PriceChange } from "@crypto-trading/common/browser";

export type CandleInterval = "1m" | "5m" | "15m" | "30m" | "1h" | "4h" | "1d";

export const CANDLE_INTERVAL_MS: Record<CandleInterval, number> = {
  "1m": 60 * 1000,
  "5m": 5 * 60 * 1000,
  "15m": 15 * 60 * 1000,
  "30m": 30 * 60 * 1000,
  "1h": 60 * 60 * 1000,
  "4h": 4 * 60 * 60 * 1000,
  "1d": 24 * 60 * 60 * 1000,
};

export interface CandlePoint {
  startTime: number;
  openPrice: string;
  highPrice: string;
  lowPrice: string;
  closePrice: string;
  volume?: string;
}

export interface CandleFetchErrorMeta {
  code:
    | "TOKEN_NOT_AVAILABLE"
    | "HISTORY_OUT_OF_RANGE"
    | "NETWORK"
    | "RATE_LIMIT"
    | "UNSUPPORTED"
    | "UNKNOWN";
  message: string;
}

const RAW_EXCHANGE_REQUEST_ERROR = /request failed/i;

/** Exchange HTTP failures stay out of the chart. Callers render this string instead. */
export function toPublicChartErrorMessage(message: string): string {
  if (RAW_EXCHANGE_REQUEST_ERROR.test(message)) {
    return "Price chart is temporarily unavailable";
  }
  return message;
}

export function toPriceChange(candle: CandlePoint): PriceChange {
  return {
    startTime: candle.startTime,
    openPrice: candle.openPrice,
    highPrice: candle.highPrice,
    lowPrice: candle.lowPrice,
    closePrice: candle.closePrice,
    volume: candle.volume ?? "0",
    turnover: "0",
  };
}

